import { Box } from '@mui/material'
import { ObjectFieldTemplateProps } from '@rjsf/utils'

export function ObjectFieldTemplate(props: ObjectFieldTemplateProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        flexWrap: 'wrap',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: (theme) => theme.spacing(4),
        alignItems: 'flex-start',
        '& .object-field-template': {
          // for children items that are also object-field-template classes
          gridColumn: props.properties.length <= 1 ? '1 / -1' : undefined,
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '48% 48%',
          alignItems: 'flex-start',
          gap: '16px',
          '& > .object-field-property': {
            width: '100%',
            height: '72px',
          },
        },
      }}
      className={'object-field-template'}
    >
      {props.description}
      {props.properties.map((element, index) => {
        return (
          <Box
            key={index}
            hidden={element.hidden}
            className={'object-field-property'}
            sx={{
              width: '100%',
              gridColumn: props.properties.length <= 1 ? '1 / -1' : undefined,
            }}
          >
            {element.content}
          </Box>
        )
      })}
      {/* </Box> */}
    </Box>
  )
}
